module.exports = __webpack_public_path__ + "static/img/jiaoben.8b6e2b6d.png";